import BaseServiceV2 from "./BaseServiceV2";
import ApiUrl from './ApiUrl';

class SGKEviziterapordurumlariService extends BaseServiceV2 {

    constructor() {
        super(ApiUrl.SGKDomain + ApiUrl.controller.sgkeviziterapordurumlari);
    }
}

const sgkeviziterapordurumlari = new SGKEviziterapordurumlariService();

export default sgkeviziterapordurumlari;